module.exports = __webpack_public_path__ + "img/banners-pa-mobile.5f295e8e.png";